/** Curated English passages for Træningsbane (~250–300 chars, niveau 5+). */

import type { FlowChunk } from './chunks-da';

export const FLOW_CHUNKS_EN: FlowChunk[] = [
  {
    topic: 'bees',
    text: 'Bees fly far to find nectar from flowers in gardens and fields. They dance on the hive to show other bees where food is. A worker bee may visit hundreds of flowers in one day. Bees are important for our food because they pollinate plants. A hive can hold thousands of bees in summer.',
  },
  {
    topic: 'ocean',
    text: 'The ocean covers most of Earth and shapes weather across the world. Waves roll onto the beach every day and change sand and rocks. Many fish live deep below the surface where it is dark and cold. Ocean currents move heat around the planet. Diving takes calm, practice and respect for nature.',
  },
  {
    topic: 'winter',
    text: 'In winter the days grow shorter in the north, and darkness comes early. Frost can cover lakes and canals with a thin layer of ice. People wear warm coats before they go out into the cold air. Trees lose their leaves but wait for spring under the bark. Winter also gives time for rest, reading and hot cocoa.',
  },
  {
    topic: 'body',
    text: 'The heart pumps blood around the body all the time, even when you sleep. The lungs take in air when you breathe and send oxygen into the blood. Muscles help you move, run and keep your balance. Bones support the body, and skin protects against germs. The body is a team of many parts.',
  },
  {
    topic: 'bicycle',
    text: 'A bicycle has two wheels and a chain that drives the back wheel forward. Many people cycle to school and work, even when it rains a little. A helmet protects your head if you fall, and lights help in the dark. Cycling strengthens your legs and fills your lungs with fresh air. It is a cheap and good way to travel.',
  },
  {
    topic: 'books',
    text: 'A book has many pages filled with text that tells a story or explains an idea. Libraries lend books for free so everyone can read. It is nice to read a good story in the evening when the day is quiet. Reading trains language and brings new ideas. Some books stay with you long after the last page.',
  },
  {
    topic: 'food',
    text: 'Vegetables and fruit give vitamins to the body so you can stay healthy. Bread and soup are simple meals on a cold day. It is good to drink water during the day, especially when you are busy. Meals can bring family and friends together at a table. Good food does not need to be fancy to taste great.',
  },
  {
    topic: 'space',
    text: 'The Moon moves around Earth about once a month and affects tides along the coast. The Sun is a star that gives us light, heat and energy for plants. Astronauts have walked on the Moon and took pictures of Earth from there. Space is vast and cold, and there is no air to breathe. Telescopes help us see far away.',
  },
  {
    topic: 'seasons',
    text: 'Spring comes when trees grow buds and birds return from long trips. In summer the sky stays bright late in the evening, and people are often outside. Autumn brings red and yellow leaves that fall to the ground. Winter feels long but makes spring wonderful when it returns. Seasons change slowly and give rhythm to the year.',
  },
  {
    topic: 'animals',
    text: 'The dog was one of the first animals people tamed, and it can be a loyal friend. Cats sleep for many hours each day and chase toys with quiet paws. Birds build nests to lay eggs and care for young until they can fly. Animals live in forests, fields and seas, each in its own way. We share the planet with them.',
  },
  {
    topic: 'music',
    text: 'Music can make people sing and dance together, even when they are strangers. A choir sings in several parts at once and must listen to each other. Practice makes it easier to play an instrument and find the rhythm. Some songs remind us of a certain time or place. Music can be quiet and also very powerful.',
  },
  {
    topic: 'sleep',
    text: 'Children need more sleep than adults because the body grows and learns so much. The body rests and repairs itself at night while dreams come and go. It is harder to focus when you are tired, and mistakes happen more easily. A calm evening without screens can help you fall asleep. Good sleep is a gift for the next day.',
  },
];
